import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {EbitdaData, EbitdaReportDto} from '../../../../../Models/Finances/Ebitda/ebitda-report.interface';
import {EbitdaApiService} from '../../../../../Services/Api/Finances/Ebitda/ebitda-api.service';
import {EbitdaFilters} from '../../../../../Models/Finances/Ebitda/ebitda-filters.model';

@Component({
  selector: 'app-ebitda-income-widget',
  templateUrl: './ebitda-income-widget.component.html',
  styleUrls: ['./ebitda-income-widget.component.scss'],
  standalone: false
})
export class EbitdaIncomeWidgetComponent extends WidgetDataControllerComponent<EbitdaData> {

  get widgetData(): EbitdaData {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected ebitdaService: EbitdaApiService,
  ) {
    super(injector, ebitdaService);

    this.getFakeData();
  }


  /**
   * Obtener datos falsos
   *
   */
  getFakeData() {
    this.fakeData = {
      last_importe: 252208.86,
      importe: 189702.41,
      porcentaje: -24.78,
      diferencia_porcentaje: 0,
      diferencia_importe: 0,
      last_porcentaje: 0,
    };
  }


  /**
   * Obtener los ingresos
   *
   */
  override setData(data: EbitdaReportDto) {
    this.data = data.ingresos;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const params: EbitdaFilters = new EbitdaFilters();

    if (this.widgetsManager.filters) {
      params.filtro_local = this.widgetsManager.filters.local?.id || params.filtro_local;
      params.fecha_desde = this.widgetsManager.filters.fecha_inicio || params.fecha_desde;
      params.fecha_hasta = this.widgetsManager.filters.fecha_fin || params.fecha_hasta;
    }

    return this.ebitdaService.getReportEbitda(params, false);
  }

}
